<div *ngIf="vm$ | async as vm">
  <form [formGroup]="vm.form">
    <formly-form [fields]="vm.fields" [model]="vm.model" [options]="vm.options" [form]="vm.form"></formly-form>
  </form>
  <om-debug title="MODEL" [data]="vm.model"></om-debug>
</div>
